<template>
  <button-base :channel="channel" :show-button-labels="showButtonLabels" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import FacebookMixin from '@/share/campaign/facebook-mixin'

export default {
  components: { ButtonBase },

  mixins: [FacebookMixin],

  props: {
    channel: {
      type: Object,
      required: true
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    }
  }
}
</script>
